import { render, staticRenderFns } from "./detailWhiteSectionPortfolio.vue?vue&type=template&id=022c1533&"
import script from "./detailWhiteSectionPortfolio.vue?vue&type=script&lang=js&"
export * from "./detailWhiteSectionPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "detailWhiteSectionPortfolio.vue"
export default component.exports